@let positionDataValue = positionData()!;

<rt-dialog-header
  class="error"
  [heading]="'tlc.positions.delete_position_dialog.header' | translate"
/>

<rt-dialog-body variant="white">
  <div class="position-container">
    <div class="position-icon">
      <rt-icon name="positions" colorToken="colorIconPrimaryDefault" />
    </div>
    <div class="position-details">
      <span class="position-name">{{ positionDataValue.name }}</span>
      <span class="count">{{
        'tlc.positions.delete_position_dialog.members_count'
          | translate: { count: positionDataValue.membersCount }
      }}</span>
    </div>
  </div>
  <div class="info-container">
    <span class="info-text">{{ 'tlc.positions.delete_position_dialog.info' | translate }}</span>
    <rt-checkbox [checked]="confirmed()" (valueChange)="onConfirmedChange($event)">
      <span class="checkbox-text">{{
        'tlc.positions.delete_position_dialog.checkbox_text' | translate
      }}</span>
    </rt-checkbox>
  </div>
</rt-dialog-body>
<rt-dialog-footer [hasOptionalActions]="true">
  <rt-button
    class="optional"
    variant="error"
    (click)="delete()"
    [disabled]="!confirmed()"
    [loading]="loading()"
  >
    {{ 'tlc.positions.delete_position_dialog.confirm' | translate }}
  </rt-button>
  <rt-button variant="plain" (click)="cancel()">
    {{ 'tlc.common.cancel' | translate }}
  </rt-button>
</rt-dialog-footer>
